/** Header nav links visible from md (960px+). */
export const DESKTOP_NAV_DISPLAY = ["none", "none", "flex"];

/** Accounts / Support: hidden between md and lg (960–1279px), visible from lg (1280px+). */
export const LARGE_DESKTOP_NAV_DISPLAY = ["none", "none", "none", "flex"];
